import './product-variants.scss';
import '../../../../node_modules/js-cloudimage-360-view/dist/index.js';
import { isInViewport, smoothScrollTo, getOffset } from '../../../utilities/js/helper';

class ProductVariants {
    constructor ($element) {
        this.$productVariants = $element;
        this.$360Image = this.$productVariants.querySelector('.product-variants__images-view-item.is--first');
        this.$colorItems = this.$productVariants.querySelectorAll('[data-product-variants-color]');
        this.$productVariantImages = this.$productVariants.querySelector('[data-product-variants-images]');

        this.played = false;
        this.animationInterval = null;
    }

    initialize () {
        if (this.$360Image) {
            this.init360View();
            this.setAnimation();
            this.checkScrolling();
        }

        if (this.$colorItems.length > 0) {
            this.setEvents();
        }
    }

    init360View () {
        window.CI360.init();
    }

    checkScrolling () {
        window.eventScroller.customFunctions.push(() => {
            this.setAnimation();
        });
    }

    setAnimation () {
        const inViewport = isInViewport(this.$productVariants);
        if (inViewport && !this.played) {
            const $initViewItem = this.$productVariants.querySelector('.product-variants__images-view-item.is--init');
            const initViewItemsCount = $initViewItem.getAttribute('data-amount-x');
            $initViewItem.classList.add('cloudimage-360');
            this.init360View();
            this.played = true;
            this.animationInterval = setInterval(() => {
                const id = $initViewItem.id;
                const activeIndex = window.CI360.getActiveIndexByID(id);
                if (activeIndex + 1 === parseInt(initViewItemsCount)) {
                    clearInterval(this.animationInterval);
                    setTimeout(() => {
                        $initViewItem.classList.add('is--hidden');
                    }, 100);
                }
            }, 100);
        }
    }

    setEvents () {
        for (let i = 0; i < this.$colorItems.length; i++) {
            const $colorItem = this.$colorItems[i];

            $colorItem.addEventListener('click', () => {
                clearInterval(this.animationInterval);
                this.$productVariants.querySelector('.product-variants__images-view-item.is--init').classList.add('is--hidden');
                const color = $colorItem.getAttribute('data-product-variants-color');
                const $currentView = this.$productVariants.querySelector('.cloudimage-360');
                const $newView = this.$productVariants.querySelector('.view--' + color);

                for (let j = 0; j < this.$colorItems.length; j++) {
                    this.$colorItems[j].classList.remove('is--active');
                }
                $colorItem.classList.add('is--active');

                $currentView.classList.remove('cloudimage-360');
                $currentView.classList.remove('initialized');
                $currentView.innerHTML = '';
                $newView.removeAttribute('data-autoplay');
                $newView.removeAttribute('data-play-once');
                $newView.classList.add('cloudimage-360');
                this.init360View();
                smoothScrollTo(0, getOffset(this.$productVariants).top, 500);
            });
        }
    }
}

export { ProductVariants };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $productVariants = $context.querySelectorAll('[data-product-variants]');
        if ($productVariants.length > 0) {
            $productVariants.forEach((productVariantsItem) => {
                const $productVariant = new ProductVariants(productVariantsItem);
                $productVariant.initialize();
            });
        }
    }
});
